/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import {
    array, bool, func, object, string,
} from 'prop-types';
import { useDispatch } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import { List, MenuItem } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import ErrorMessage from '../ErrorMessage/ErrorMessage';

import { getCountryDetailsByThreeDigitCountryCode } from '../../../../../../../state/ducks/Checkout/helpers/countryCode';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    modalBox: {
        margin: '10px !important',
        maxHeight: '690px',
        minHeight: '370px',
        maxWidth: '460px',
        width: 'auto',
        minWidth: '460px',
        borderRadius: '12px',
        [theme.breakpoints.down('sm')]: {
            minWidth: '320px',
            maxWidth: '375px',
            maxHeight: '690px',
            minHeight: '380px',
        },
        '@media (max-height: 428px)': {
            height: 'calc(100vh - 24px)',
            maxHeight: 'initial',
            minHeight: 'initial',
        },
    },
    modalBoxNoSuggestion: {
        minHeight: '278px',
        maxHeight: '278px',
        [theme.breakpoints.down('sm')]: {
            minHeight: '278px',
            maxHeight: '278px',
        },
    },
    modalBoxNoSuggestionLine2: {
        minHeight: '292px',
        maxHeight: '292px',
        [theme.breakpoints.down('sm')]: {
            minHeight: '292px',
            maxHeight: '292px',
        },
    },
    modalBoxSuggestionExpanded: {
        '@media (max-height: 575px)': {
            height: 'calc(100vh - 60px)',
            maxHeight: 'initial',
            minHeight: 'initial',
        },
    },
    header: {
        fontSize: '1em',
        padding: '0',
        margin: '0',
    },
    formControl: {
        minWidth: '100%',
    },
    menuContainer: {
        height: '200px',
    },
    title: {
        margin: 0,
        padding: '13px 0',
    },
    closeQAS: {
        border: 0,
        margin: 0,
        padding: '6px 0',
        backgroundColor: 'white',
        boxShadow: 'none',
        width: '42px',
        minWidth: '10px',
        color: 'black',
        '&:hover, &:focus, &:active, &:visited': {
            backgroundColor: 'white',
            color: 'black',
            boxShadow: 'none',
        },
    },
    dialogContent: {
        overflowY: 'auto',
        padding: '0 16px 10px',
        margin: '0',
        '@media (max-height: 690px)': {
            padding: '0 16px 0',
        },
        '@media (max-height: 575px)': {
            overflowY: 'scroll !important',
            overflow: '-moz-scrollbars-vertical',
            '&::-webkit-scrollbar': {
                '-moz-appearance': 'none',
                '-webkit-appearance': 'none',
                background: '#C4C4C4',
                width: '8px',
            },

            '&::-webkit-scrollbar-thumb': {
                borderRadius: '4px',
                backgroundColor: '#7B7B7B',
            },
        },
    },
    dialogContentNoSuggestion: {
        overflowY: 'hidden !important',
    },
    descInfo: {
        fontWeight: 600,
        fontSize: '1.25em',
        lineHeight: '1em',
        [theme.breakpoints.down(360)]: {
            fontSize: '1.1em',
        },
    },
    titleEntered: {
        fontWeight: 600,
        margin: '16px 0',
    },
    iconControl: {
        position: 'relative',
        width: '30px',
        display: 'block',
    },
    iconIndicator: {
        position: 'absolute',
        top: '10px',
        left: 0,
        height: '16px',
        width: '16px',
        background: '#fff',
        border: '1px solid #7B7B7B',
        borderRadius: '50%',
    },
    iconIndicatorSelected: {
        position: 'absolute',
        top: '10px',
        left: 0,
        height: '16px',
        width: '16px',
        background: '#fff',
        border: '1px solid #7B7B7B',
        borderRadius: '50%',
        '&:after': {
            boxSizing: 'unset',
            content: '""',
            position: 'absolute',
            display: 'block',
            left: 'calc(50% - 4px)',
            top: 'calc(50% - 4px)',
            height: '8px',
            width: '8px',
            borderRadius: '50%',
            background: '#000',
            transition: 'background 250ms',
        },
        '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            left: 0,
            top: '10px',
            width: '16px',
            height: '16px',
            marginLeft: '0',
            marginTop: '0',
            background: '#fff',
            borderRadius: '3rem',
            opacity: '1',
            zIndex: '1',
            transform: 'scale(0)',
        },
    },
    textInfo: {
        fontSize: '0.9em',
        lineHeight: '1.1em',
        fontWeight: 'normal',
    },
    titleWeSuggest: {
        padding: '0 0 16px',
    },
    shipToAddress: {
        margin: '0',
    },
    address: {
        fontSize: '1em',
        fontWeight: '500',
        color: '#555555',
        lineHeight: '1.1em',
        margin: '0',
    },
    addressSelected: {
        color: '#000',
    },
    editAddressQas: {
        backgroundColor: 'white',
        border: 0,
        boxShadow: 'none',
        color: `${theme.palette.primary?.main}`,
        display: 'block',
        fontWeight: '600',
        fontSize: '0.875em !important',
        margin: '0',
        lineHeight: '1em',
        padding: '0 0 10px',
        textAlign: 'right',
        textDecoration: 'underline',
        textTransform: 'none',
        width: '100%',
        minWidth: '30px',
        transitions: 'none',
        '&:hover, &:focus, &:active, &:visited, &:focus-visible': {
            backgroundColor: 'white',
            color: `${theme.palette.primary?.main}`,
            boxShadow: 'none',
        },
    },
    qasShipAddress: {
        margin: '0',
        padding: '0',
        cursor: 'pointer',
    },
    saveBtn: {
        backgroundColor: theme.palette.primary?.main,
        border: 0,
        borderRadius: '4px',
        color: theme.palette.primary?.contrastText,
        fontSize: '1em',
        fontWeight: 'bold',
        margin: '14px 0',
        padding: '14px 28px',
        textAlign: 'center',
        textTransform: 'none',
        width: '100%',
        boxShadow: 'none',
        '&:hover, &:focus, &:active, &:visited': {
            backgroundColor: theme.palette.primary?.main,
            color: theme.palette.primary?.contrastText,
            boxShadow: 'none',
        },
    },
    rootList: {
        padding: 0,
    },
    suggestionListRoot: {
        margin: 0,
        padding: 0,
        overflow: 'hidden',
    },
    suggestionCont: {
        margin: '0 0 16px 0',
        border: '1px solid #E9E9E9',
        padding: '0',
        borderRadius: '3px',
        transition: '0.4s ease-in-out ',
        transform: 'translateY(0)',
    },
    hideSuggestions: {
        transform: 'translateY(-100%)',
        height: 0,
        margin: 0,
    },
    suggestionListContainer: {
        boxShadow: 'none;',
        borderRadius: '3px',
        backgroundColor: 'white',
        height: '125px',
        overflowY: 'scroll !important',
        overflow: '-moz-scrollbars-vertical',
        '&::-webkit-scrollbar': {
            '-moz-appearance': 'none',
            '-webkit-appearance': 'none',
            background: '#D9D9D9',
            width: '8px',
        },

        '&::-webkit-scrollbar-thumb': {
            borderRadius: '4px',
            backgroundColor: '#7B7B7B',
            boxShadow: 'none',
        },
        '@media (max-height: 690px)': {
            height: '193px',
        },
        '@media (max-height: 670px)': {
            height: '129px',
        },
        '&$hideSuggestions': {
            transform: 'translateY(-100%)',
            height: 0,
        },
    },
    suggestionListContNoScroll: {
        borderRadius: '3px',
        backgroundColor: 'white',
        boxShadow: 'none',
        maxHeight: '256px',
    },
    titleSuggestionList: {
        borderTop: '1px solid #C4C4C4',
        padding: '16px 0 0',
        margin: '24px 0 15px',
        fontSize: '1em',
        fontWeight: '700',
    },
    resultInfo: {
        fontWeight: 'normal',
        color: '#555555',
        textAlign: 'right',
        padding: '0 0 16px',
        fontSize: '0.75em',
    },
    resultInfoCollapse: {
        fontWeight: 'normal',
        color: '#555555',
        textAlign: 'right',
        padding: '5px 0',
        fontSize: '0.75em',
    },
    addressMenuItem: {
        backgroundColor: 'white',
        fontSize: '1em',
        padding: '4px 8px',
        width: '100%',
        '&:hover, &:focus, &:active, &:visited': {
            backgroundColor: '#FAFAFA',
        },
    },
    addressMenuSelected: {
        backgroundColor: '#FAFAFA',
        fontSize: '1em',
        padding: '4px 8px',
        width: '100%',
        '&:hover, &:focus, &:active, &:visited': {
            backgroundColor: '#FAFAFA',
        },
    },
    addressPrimaryLine: {
        fontSize: '0.875em',
        color: 'black',
        display: 'block',
        lineHeight: '1em',
    },
    addressSecondaryLine: {
        fontSize: '0.875em',
        fontWeight: '500',
        color: '#555555',
        lineHeight: '1em',
        margin: '2px 0 0',
        display: 'block',
    },
    buttonNoSuggestion: {
        borderTop: '1px solid #C4C4C4',
        padding: '10px 0 0',
        marginTop: '24px',
    },
    btnItem: {
        fontSize: '0.875em !important',
        fontWeight: '600',
        color: theme.palette.primary.main,
        textDecoration: 'underline',
        textTransform: 'none',
        padding: 0,
        margin: '0 -7px 10px 0',
        transition: 'none',
        '&:hover, &:focus, &:active, &:visited': {
            backgroundColor: 'transparent',
            color: theme.palette.primary.main,
            textDecoration: 'underline',
        },
    },
    icon: {
        color: theme.palette.primary.main,
        display: 'inline-block',
        fontSize: '25px',
        verticalAlign: 'middle',
        padding: '0',
        margin: '0 0 0 -2px',
    },
});

const QASAddressContainerV2 = ({
    addressItemPosition,
    addressSelected,
    classes,
    editVerificationQAS,
    featureFlags,
    handleKeepCurrentAddress,
    handleSelectedAddress,
    orderItemError,
    recipientQASData,
    saveVerificationQAS,
    showAddressValidation,
    suggestionList,
    typeData,
    versionQAS,
}) => {
    const dispatchAction = useDispatch();

    const [isOpenMoreSuggestions, setOpenMoreSuggestions] = useState(false);
    const [addressSuggestedSelected, setAddressSuggestedSelected] = useState({
        address: {},
        index: null,
    });
    const isCollapseLinkEnabled = featureFlags['is-qas-modal-collapse-link-enabled'] || false;

    let classModalRoot = classes.modalBox;
    if (suggestionList?.length === 0) {
        classModalRoot += ` ${classes.modalBoxNoSuggestion}`;
        if (recipientQASData.address2) {
            classModalRoot += ` ${classes.modalBoxNoSuggestionLine2}`;
        }
    } else if (isOpenMoreSuggestions) {
        classModalRoot += ` ${classes.modalBoxSuggestionExpanded}`;
    }

    useEffect(() => {
        dispatchAction(trackEvent({
            eventCategory: 'Experiment',
            eventAction: 'QAS Modal UI Update',
            eventLabel: 'Variant',
        }));

        if (suggestionList.length === 1) {
            dispatchAction(trackEvent({
                eventCategory: 'Checkout',
                eventAction: 'QAS Modal',
                eventLabel: 'One suggestion',
            }));
        } else if (suggestionList.length > 1) {
            dispatchAction(trackEvent({
                eventCategory: 'Checkout',
                eventAction: 'QAS Modal',
                eventLabel: 'Multiple suggestions',
            }));
        } else {
            dispatchAction(trackEvent({
                eventCategory: 'Checkout',
                eventAction: 'QAS Modal',
                eventLabel: 'No suggestions',
            }));
        }
    }, []);

    const handleCloseModal = () => {
        dispatchAction(trackEvent({
            eventCategory: 'Checkout',
            eventAction: 'QAS Modal',
            eventLabel: 'Close click',
        }));

        editVerificationQAS();
    };

    const handleEditAddress = () => {
        dispatchAction(trackEvent({
            eventCategory: 'Checkout',
            eventAction: 'QAS Modal',
            eventLabel: 'Edit click',
        }));

        editVerificationQAS();
    };

    const handleSuggestedAddressSelected = (address, index) => {
        if (addressSelected.index === null && index !== null) {
            const element = document.getElementById(`item-${index}`);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
        setAddressSuggestedSelected({ address, index });
        handleSelectedAddress(address, index);
    };

    const getSuggestionList = () => {
        if (suggestionList.length > 1) {
            return (
                <Grid container>
                    {
                        isCollapseLinkEnabled
                        && (
                            <>
                                <Grid items xs={8}>

                                    <Button
                                        aria-label="Expand Suggrestiong"
                                        id="more-suggestion-btn"
                                        data-test="more-suggestion-btn"
                                        name="moreSuggestionBtn"
                                        className={classes.btnItem}
                                        onClick={() => setOpenMoreSuggestions(!isOpenMoreSuggestions)}
                                        tabIndex={0}
                                    >
                                        {
                                            !isOpenMoreSuggestions
                                                ? <span>See more suggestions<ExpandMoreIcon className={classes.icon} /></span>
                                                : <span>See less<ExpandLessIcon className={classes.icon} /></span>
                                        }
                                    </Button>

                                </Grid>
                                <Grid className={classes.resultInfoCollapse} item xs={4}>
                                    {
                                        suggestionList.length > 1 && isOpenMoreSuggestions
                                            ? `${suggestionList.length} Results`
                                            : null
                                    }
                                </Grid>
                            </>
                        )
                    }
                    <Grid container className={`${classes.suggestionListRoot}`}>
                        <Grid item xs={12} className={`${classes.suggestionCont} ${!isOpenMoreSuggestions && isCollapseLinkEnabled ? classes.hideSuggestions : ''} ${suggestionList?.length < 5 ? classes.suggestionListContNoScroll : classes.suggestionListContainer}`} tabIndex={0}>
                            <List id="suggestionList" className={classes.rootList}>
                                {
                                    suggestionList.map((address, index) => {
                                        const addressInfo = address[addressItemPosition]?.split(',');
                                        const addressInfoLine1 = address[addressItemPosition]?.split(',', 1);
                                        const addressInfoLine2 = address[addressItemPosition]?.split(',').slice(1).join(', ');

                                        return (
                                            <MenuItem
                                                id={`item-${index}`}
                                                value={index}
                                                className={addressSelected.index === index ? classes.addressMenuSelected : classes.addressMenuItem}
                                                key={addressInfo}
                                                onClick={() => handleSuggestedAddressSelected(address, index)}
                                                tabIndex={0}
                                            >
                                                <Grid id={`textAddress-${index}`} container>
                                                    <Grid id={`textAddressLine1-${index}`} item xs={12} className={classes.addressPrimaryLine}>{addressInfoLine1[0]}</Grid>
                                                    <Grid id={`textAddressLine2-${index}`} item xs={12} className={classes.addressSecondaryLine}>{addressInfoLine2}</Grid>
                                                </Grid>
                                            </MenuItem>
                                        );
                                    })
                                }
                            </List>
                        </Grid>
                    </Grid>
                </Grid>
            );
        }
        return null;
    };

    const getSuggestionContainer = () => {
        const addressInfoLine1 = suggestionList[addressSuggestedSelected.index || 0]?.[addressItemPosition]?.split(',', 1);
        const addressInfoLine2 = suggestionList[addressSuggestedSelected.index || 0]?.[addressItemPosition]?.split(',').slice(1).join(', ');

        return (
            <Grid id="new-qas-list" container>
                <Grid className={classes.titleSuggestionList} item xs={12}>
                    <Grid container>
                        <Grid item xs={8} className={classes.titleWeSuggest}>
                            We Suggest:
                        </Grid>
                        <Grid className={classes.resultInfo} item xs={4}>
                            {!isCollapseLinkEnabled && suggestionList.length > 1 ? `${suggestionList.length} Results` : null}
                        </Grid>
                        <Grid item xs={12}>
                            <Grid
                                id="qas-suggested-address"
                                container
                                className={`${classes.qasShipAddress} ${addressSelected.index !== null ? classes.qasShipAddressSelected : ''}`}
                                onClick={() => handleSuggestedAddressSelected(suggestionList[addressSuggestedSelected.index || 0], addressSuggestedSelected.index || 0)}
                                tabIndex="0"
                            >
                                <Grid container>
                                    <div className={classes.iconControl}>
                                        <div className={addressSelected.index !== null ? classes.iconIndicatorSelected : classes.iconIndicator}>&nbsp;</div>
                                    </div>
                                    <div id="textAddressSuggested" className={`${classes.address} ${addressSelected.index !== null ? classes.addressSelected : ''}`} align="left">
                                        {addressInfoLine1[0]}
                                        <br />
                                        {addressInfoLine2}
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        {getSuggestionList()}
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    const shipToAddress = () => {
        let isPoBox = false;
        let PoBoxAddressLine1 = '';

        if (recipientQASData?.locationType?.includes('P.O.Box') && recipientQASData?.address1) {
            isPoBox = true;
            const extraPoboxText = recipientQASData.address1.slice(7, 13).toLowerCase();
            const defaultPoboxText = recipientQASData.address1.slice(0, 6).toLowerCase();
            if (((/(po)(\s|box)+/g).test(extraPoboxText))) {
                PoBoxAddressLine1 = recipientQASData.address1.replace('PO Box', '').trim();
            } else if (!(/(po)(\s|box)+/g).test(defaultPoboxText)) {
                PoBoxAddressLine1 = `PO Box ${recipientQASData.address1}`;
            } else {
                PoBoxAddressLine1 = recipientQASData.address1;
            }
        }

        let country = recipientQASData.country;
        if (country?.length === 3) {
            const countryObj = getCountryDetailsByThreeDigitCountryCode(country);
            country = countryObj.countryCodeTwoDigit;
        }

        return (
            <Grid
                id="suggested-address"
                container
                className={`${classes.qasShipAddress}`}
                onClick={handleKeepCurrentAddress}
                tabIndex={0}
            >
                <Grid item xs={12}>
                    <Grid container className={classes.shipToAddress}>
                        <Grid item xs={12} className={classes.titleEntered}>
                            You Entered:
                        </Grid>
                        <Grid item xs={10}>
                            <Grid container>
                                <div className={classes.iconControl}>
                                    <div className={addressSelected.index === null ? classes.iconIndicatorSelected : classes.iconIndicator}>&nbsp;</div>
                                </div>
                                <div className={`${classes.address} ${addressSelected.index === null ? classes.addressSelected : ''}`} align="left">
                                    {
                                        isPoBox
                                            ? PoBoxAddressLine1
                                            : recipientQASData.address1
                                    }
                                    {
                                    recipientQASData.address2?.trim()
                                        ? <><br />{recipientQASData.address2}</>
                                        : null
                                    }
                                    {<><br />{recipientQASData.city}, {recipientQASData.state} {recipientQASData.zipCode}, {country}</>}
                                </div>
                            </Grid>
                        </Grid>
                        <Grid item xs={2}>
                            <Button
                                id="edit-address-qas"
                                name="edit-address-qas"
                                variant="contained"
                                className={classes.editAddressQas}
                                data-test="checkout-recipient-address-edit"
                                onClick={handleEditAddress}
                                tabIndex={0}
                            >
                                Edit
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    return (
        <Dialog
            id={`DialogNewQASAddress${typeData}-${versionQAS}`}
            classes={{
                paper: classModalRoot,
            }}
            open={showAddressValidation}
            data-testid={`DialogQASAddress${typeData}`}
        >
            <Grid container className={classes.header}>
                <Grid item xs={10}>&nbsp;</Grid>
                <Grid item xs={2}>
                    <Grid container justifyContent="flex-end">
                        <Button
                            id="close-new-qas"
                            name="close-qas"
                            variant="contained"
                            color="primary"
                            data-test="checkout-recipient-address-edit"
                            className={classes.closeQAS}
                            onClick={handleCloseModal}
                            tabIndex={0}
                        >
                            <CloseIcon />
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <Grid className={`${classes.dialogContent} ${suggestionList?.length === 0 ? classes.dialogContentNoSuggestion : ''}`}>
                {orderItemError ? (
                    <ErrorMessage
                        noShadow
                        error={orderItemError}
                    />
                ) : null}
                <Grid container className={classes.descInfo}>
                    {'We couldn\'t verify your address.'}
                </Grid>
                {shipToAddress()}
                {
                    suggestionList.length > 0
                    && getSuggestionContainer()
                }
                <Grid container className={suggestionList?.length === 0 ? classes.buttonNoSuggestion : ''}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Button
                            id="save-address-qas"
                            name="save-address-qas"
                            variant="contained"
                            className={classes.saveBtn}
                            data-test="checkout-recipient-address-save"
                            onClick={saveVerificationQAS}
                            tabIndex={0}
                        >
                            {suggestionList?.length === 0 ? 'Keep address as entered' : 'Use Selected Address'}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    );
};

QASAddressContainerV2.propTypes = {
    addressItemPosition: string.isRequired,
    addressSelected: object.isRequired,
    classes: object.isRequired,
    editVerificationQAS: func.isRequired,
    featureFlags: object.isRequired,
    handleKeepCurrentAddress: func.isRequired,
    handleSelectedAddress: func.isRequired,
    orderItemError: string,
    recipientQASData: object.isRequired,
    saveVerificationQAS: func.isRequired,
    showAddressValidation: bool.isRequired,
    suggestionList: array.isRequired,
    typeData: string,
    versionQAS: string.isRequired,
};

QASAddressContainerV2.defaultProps = {
    typeData: '',
    orderItemError: null,
};
export default withStyles(styles)(QASAddressContainerV2);
